import moment from 'moment';
import { validateEmail } from 'utils/helper';
import { numberUnmask, removeSpace, removeUnderline } from 'utils/masks';

const KBAIdentityVerificationSchema = {
  applicantName: [{
    rule: 'required',
    isValid: (input) => {
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      }
      if (input.length > 40) {
        return 'The input field is too long';
      }
      if (input.trim().split(' ').length < 2) {
        return 'Please enter your full name';
      }
      if (!/^[a-zA-Z\s-']+$/.test(input)) {
        return 'Please enter a valid name, with only letters, - and \'.';
      }
      return true;
    },
  }],
  last4ssn: [{
    rule: 'required',
    isValid: (input) => {
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      } else if (removeUnderline(input).length !== 4) {
        return 'Invalid SSN';
      }
      return true;
    },
  }],
  mobileNumber: [{
    rule: 'required',
    isValid: (input) => {
      const phoneNumbers = [
        '(111) 111-1111',
        '(222) 222-2222',
        '(333) 333-3333',
        '(444) 444-4444',
        '(555) 555-5555',
        '(666) 666-6666',
        '(777) 777-7777',
        '(999) 999-9999',
      ];

      if (!input) {
        return 'The input field is required';
      }

      return (
        numberUnmask(input).length < 10 ||
        phoneNumbers.indexOf(input || '') !== -1 ||
        (input && input.charAt(1) === '0') ||
        (input && input.charAt(1) === '1') ||
        (input && input.substring(6) === '000-0000')
      ) ? 'Phone number is not valid' : true;
    },
  }],
  address: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  city: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  state: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  zip: [{
    rule: 'required',
    error: 'The input field is required',
    isValid: (input) => {
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      } else if (removeUnderline(input).length !== 5) {
        return 'Invalid zipcode';
      }
      return true;
    },
  }],
};

export default KBAIdentityVerificationSchema;
